import { Alert, Col, Container, Row } from 'react-bootstrap'
import React from 'react'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../common/integrations'

interface IntegrationAdminSettingsCustom {
  serviceId: IntegrationServiceId
}

export const IntegrationAdminSettingsCustom: React.FC<IntegrationAdminSettingsCustom> = ({ serviceId }) => {
  const integrationDisplayName = getIntegrationDisplayName(serviceId)
  return (
    <Container>
      <Row>
        <Col>
          <Alert variant='warning' className='d-flex gap-3 align-items-center'>
            <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
            <span className='zocks-text-gray-900'>
              This {integrationDisplayName} integration was custom-built for your organization. For any configuration changes, please connect with your
              Implementation Manager or our Support Team.
            </span>
          </Alert>
        </Col>
      </Row>
    </Container>
  )
}
